import { render, staticRenderFns } from "./transfer&promotion-details.vue?vue&type=template&id=1f48dd33&"
import script from "./transfer&promotion-details.vue?vue&type=script&lang=js&"
export * from "./transfer&promotion-details.vue?vue&type=script&lang=js&"
import style0 from "./transfer&promotion-details.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./transfer&promotion-details.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports